import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { BackgroundImage, BodyText } from "../../elements";
import { mobileIs } from "../../utils/siteUtils";
import { gtag } from "../../utils";
import "./style.scss";

const InteriorDisplay = ({ rendering, fields, page }) => {
  const {
    list
  } = fields;
  const isMobile = mobileIs()
  const [currentIndex, setCurrentIndex] = useState(null)
  const [index, setIndex] = useState(0)
  const amplifyImage = (e, index) => {
    gtag('event', 'Component_info', {
      'component_name': 'InteriorDisplay',
      'page_title': page?.name
    });
    if(isMobile) {
      e.stopPropagation();
      setCurrentIndex(index)
    }
  }

  const changeIndex = (e, index) => {
    setIndex(index)
    // dom渲染完延时计算dom的位置
    setTimeout((e) => {
      getPosition(index)
    })
  }

  const getPosition = (i) => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth;
    let scale = 1
    let doms = document.querySelectorAll('.c-interior-display .item')
    let datalist = list[i].fields.positionList
    if(datalist && datalist.length > 0) {
      if(isMobile) {
        // scale = pageWidth / mCarImage.value.width
        datalist.map((item, index) => {
          doms[index].style.left = (item.fields?.mPositionX?.value) + 'px'
          doms[index].style.bottom = (item.fields?.mPositionY?.value) * ((1.3334 * pageWidth) / 500) + 'px'
          if(item.fields?.text?.value?.length > 60) {
            item.fields.text.value = item.fields.text.value.slice(0, 59)
          }
        })
      } else {
        scale = pageWidth / list[index]?.fields?.pcBackground.value.width
        let exceedHeight = (list[index]?.fields?.pcBackground.value.height * scale - pageHeight) / 2 // 背景图上下超出的高度
        datalist.map((item, index) => {
          doms[index].style.left = (item.fields?.pcPositionX?.value) * (pageWidth / 1920) +'px'
          doms[index].style.bottom = (item.fields?.pcPositionY?.value) * (pageHeight / 1080) + 'px'
          if(item.fields?.text?.value?.length > 60) {
            item.fields.text.value = item.fields.text.value.slice(0, 59)
          }
        })
      }
    }
  }

  useEffect(() => {
    getPosition(0)
  }, [])
  const rootClasses = classNames("c-interior-display", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} style={{ backgroundImage: `url("${isMobile ? list[index]?.fields?.mBackground?.value?.src : list[index]?.fields?.pcBackground?.value?.src}")` }} onClick={(e)=>{amplifyImage(e, null)}}>
      {list[index]?.fields?.positionList && list[index]?.fields?.positionList.map((item, index) => (
        <div className={["item", index === currentIndex ? 'active' : ''].join(' ')} key={index} onClick={(e)=>{amplifyImage(e, index)}}>
          <div className="add-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M7 0V7L10 9H16V7H9V0H7Z" fill="white"/>
              <path d="M0 7H6L9 9V16H7V9H0V7Z" fill="white"/>
            </svg>
          </div>
          <div className="item-circle"></div>
          <div className="item-circle-border"></div>
          <div className="amplifyImage-bg" onClick={(e)=>{amplifyImage(e, null)}}></div>
          <RichText tag="div" className="item-text" field={item?.fields?.text} />
          <BackgroundImage {...item?.fields?.amplifyImage} className="amplifyImage" onClick={(e)=>{amplifyImage(e, null)}} />
        </div>
      ))}
      <div className="color-content">
        {list && list.length > 1 && list.map((item, i) => {
          return (<div className="color-item" key={i} onClick={(e)=>{changeIndex(e, i)}}>
            <div className={["color-image-content", i === index ? 'active' : ''].join(' ')}>
              <BackgroundImage {...item?.fields?.colorImage} className="color-image" />
            </div>
            <RichText tag="div" className={["color-name", i === index ? 'active' : ''].join(' ')} field={item?.fields?.colorName} />
          </div>)
        })}
      </div>
    </div>
  );
};

export default 	InteriorDisplay;